import React from "react";
import ComingSoon from "../components/ComingSoon/ComingSoon";


function ESummit() {
  return (
    <div className="esummit">
      <ComingSoon />
    </div>
  );
}

export default ESummit;
